<template>
    <div>
        <slot>
            <AxButton @click="$emit('save')">
                {{ $t('shared.save') }}
            </AxButton>
        </slot>
    </div>
</template>

<script>
import AxButton from './AxButton'

export default {
    name: 'FormNavigation',
    components: {
        AxButton,
    },
}
</script>
